import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { ProfileProvider } from '../context/ProfileContext';
import {
  getApprovalStatus,
  getRole,
  getStageNumber,
  getToken,
} from '../utils/auth-token-utils/cookie';

const ProtectedRoute: React.FC = () => {
  const token = getToken();
  const role = getRole();
  const stage = getStageNumber();
  const approvalStatus = getApprovalStatus();

  if (token && role === 'Supervisor') {
    if (approvalStatus && approvalStatus !== 'approved') {
      return <Navigate to="/babysitter/waitingForApproval" />;
    }
    if (stage === '1') {
      return <Navigate to="/babysitter/createProfile" />;
    } else {
      return <Navigate to="/supervisor/dashboard" />;
    }
  }
  if (token && role === 'Participant') {
    if (stage === '4') {
      return <Navigate to="/participant/dashboard" />;
    } else if (stage === '3') {
      return <Navigate to="/participant/selectplan" />;
    } else if (stage === '2') {
      return <Navigate to="/participant/inviteBabysitter" />;
    } else {
      return <Navigate to="/participant/createProfile" />;
    }
  }
  return (
    <ProfileProvider>
      <Outlet />
    </ProfileProvider>
  );
};

export default ProtectedRoute;
